import React, { useContext } from 'react';
import { Typography } from 'fronton-react';
import { formatPrice } from 'common/helpers/format-amount';
import { DataContext } from 'entries/common/widgets/context';
import { useRecoilValue } from 'recoil';
import { calculationState } from 'pages/calculation/store/calculation';
import { DEFAULT_TINT_PRICE_PER_UNIT } from 'pages/calculation/consts/tint-price.consts';
import { getTintPrice } from 'pages/calculation/helpers/get-tint-price.helper';
import { total } from './styles';

export const ColoringPrice = () => {
  const data = useContext(DataContext);
  const { count } = useRecoilValue(calculationState);

  const totalPrice = getTintPrice({ volume: data?.weight, count });

  return (
    <>
      {data?.weight ? (
        <div className={total}>
          <Typography
            color="text-primary"
            size="body_accent"
            variant="l"
            data-testid="coloring-common-price">
            {`от ${formatPrice(totalPrice)} ₽`}
          </Typography>
        </div>
      ) : null}
      <Typography color="text-primary" size="caption" variant="minor">
        {`от ${DEFAULT_TINT_PRICE_PER_UNIT} ₽ / л`}
      </Typography>
    </>
  );
};
